import { isSearchMode, isSidecarSupportedMode, SearchMode, } from '#pplx/frontend/ask-models/types/search-modes.js';
export const getSidecarSafeSearchMode = ({ isSidecarBuild, searchMode, }) => {
    if (!isSidecarBuild)
        return searchMode;
    return isSearchMode(searchMode) && isSidecarSupportedMode(searchMode)
        ? searchMode
        : SearchMode.SEARCH;
};
//# sourceMappingURL=getSidecarSafeSearchMode.js.map